/* Predictive search overlay — INXL World.
 * Ported from the Woo SiteHeader search overlay. Opens from the header search
 * button, queries Shopify's native Predictive Search API (/search/suggest.json),
 * and renders product results as a card grid. Debounced + abortable; closes on
 * Esc / scrim / close button. "View all" deep-links to the full /search page.
 */
(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  var scrim = document.querySelector('[data-search-scrim]');
  var input = overlay.querySelector('[data-search-input]');
  var status = overlay.querySelector('[data-search-status]');
  var grid = overlay.querySelector('[data-search-grid]');
  var moreWrap = overlay.querySelector('[data-search-more]');
  var moreLink = overlay.querySelector('[data-search-more-link]');
  var timer = null;
  var controller = null;

  function open() {
    overlay.hidden = false;
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    if (input) { input.value = ''; input.focus(); }
    reset();
  }
  function close() {
    overlay.hidden = true;
    if (scrim) scrim.hidden = true;
    document.body.style.overflow = '';
    if (controller) controller.abort();
  }
  function reset() {
    if (status) status.textContent = 'Start typing to search';
    if (grid) grid.innerHTML = '';
    if (moreWrap) moreWrap.hidden = true;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Artist display name — mirror of snippets/artist-name.liquid (Aquarium's vendor is
  // the person's name in Shopify; the site shows «Аквариум | БГ+»).
  function displayVendor(v) {
    var s = String(v == null ? '' : v);
    return /grebensh|гребенщ/i.test(s) ? 'Аквариум | БГ+' : s;
  }

  // Standard Shopify money formatter — the Predictive Search API returns a raw
  // decimal price (e.g. "699.95"), so we format it with the shop's money_format
  // to match the rest of the storefront (€699,95).
  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  function formatPrice(raw) {
    if (raw == null || raw === '') return '';
    var cents = Math.round(parseFloat(String(raw).replace(',', '.')) * 100);
    if (isNaN(cents)) return esc(String(raw));
    var format = window.__moneyFormat || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  // Wishlist heart for a predictive-search result (mirrors snippets/wish-heart).
  // wishlist.js wires every [data-wish-toggle]; we call its syncHearts after render.
  function heartHTML(p, img) {
    var vid = (p.variants && p.variants[0] && p.variants[0].id) || '';
    var optioned = (p.variants && p.variants.length > 1) ? '1' : '';
    return '<button type="button" class="wish-heart" data-wish-toggle aria-pressed="false" aria-label="Add to wishlist"' +
      ' data-wish-id="' + esc(p.id) + '" data-wish-handle="' + esc(p.handle) + '" data-wish-url="' + esc(p.url) + '"' +
      ' data-wish-title="' + esc(p.title) + '" data-wish-image="' + esc(img) + '" data-wish-price="' + esc(formatPrice(p.price)) + '"' +
      ' data-wish-vendor="' + esc(displayVendor(p.vendor)) + '" data-wish-variant="' + esc(vid) + '" data-wish-optioned="' + optioned + '">' +
      '<svg class="wish-heart__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20 C12 20 3.5 15 3.5 8.9 C3.5 6.1 5.7 4 8.3 4 C10 4 11.4 5 12 6.3 C12.6 5 14 4 15.7 4 C18.3 4 20.5 6.1 20.5 8.9 C20.5 15 12 20 12 20 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>' +
      '<span class="wish-heart__label" data-wish-label>Add to wishlist</span></button>';
  }

  function render(products, q) {
    if (status) status.textContent = products.length + ' result' + (products.length === 1 ? '' : 's');
    if (grid) {
      grid.innerHTML = products.map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        return '<a class="site-search__card" href="' + esc(p.url) + '">' +
          '<span class="site-search__card-media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + heartHTML(p, img) + '</span>' +
          '<span class="site-search__card-brand">' + esc(displayVendor(p.vendor)) + '</span>' +
          '<span class="site-search__card-title">' + esc(p.title) + '</span>' +
          '<span class="site-search__card-price">' + formatPrice(p.price) + '</span>' +
        '</a>';
      }).join('');
      if (window.__wishlist && window.__wishlist.syncHearts) window.__wishlist.syncHearts();
    }
  }

  function run(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    if (status) status.textContent = 'Searching…';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(prods, q);
      })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        if (status) status.textContent = 'Something went wrong';
        if (grid) grid.innerHTML = '';
        if (moreWrap) moreWrap.hidden = true;
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }
    if (scrim && e.target === scrim) { close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

  if (input) input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (controller) controller.abort();
    if (!q) { reset(); return; }
    timer = setTimeout(function () { run(q); }, 220);
  });
})();
